import { pickLocalized } from "./localized";

/** Normalize API JSONB or plain string to a multilingual object. */
export function asMultilingual(value, fallback = "") {
  if (value && typeof value === "object" && !Array.isArray(value)) {
    return { ...value };
  }
  if (typeof value === "string" && value.trim()) {
    return { en: value.trim() };
  }
  const fromPick = pickLocalized(value);
  if (fromPick) return { en: fromPick };
  return { en: fallback };
}

export function hasEnglishText(obj) {
  return !!(obj?.en && String(obj.en).trim());
}

/** Strip empty language keys before save. */
export function pruneMultilingual(obj) {
  const out = {};
  if (!obj || typeof obj !== "object") return out;
  for (const [key, val] of Object.entries(obj)) {
    if (val != null && String(val).trim()) {
      out[key] = String(val).trim();
    }
  }
  return out;
}
